"use client"
import React, { useEffect } from "react"
import { NextIntlClientProvider, IntlProvider } from "next-intl"
import nextIntlConfig from "@/next-intl.config"

type Props = {
  children: React.ReactNode
  locale: string
  messages: Record<string, any>
}

const Provider: any = (NextIntlClientProvider || IntlProvider) as any

export default function NextIntlProviderClient({ children, locale, messages }: Props) {
  useEffect(() => {
    try {
      const shouldLog = typeof window !== 'undefined' && (process.env.NEXT_PUBLIC_DEBUG_I18N === '1')
      if (shouldLog) {
        const topKeys = messages && typeof messages === 'object' ? Object.keys(messages).slice(0, 20) : []
        const footerKeys = messages && messages.footer && typeof messages.footer === 'object' ? Object.keys(messages.footer) : null
        console.debug("NextIntlProviderClient mounted", { locale, hasMessages: !!messages, topKeys, footerKeys })
      }
    } catch (err) {
      if (process.env.NEXT_PUBLIC_DEBUG_I18N === '1') console.debug("NextIntlProviderClient mounted", { locale, hasMessages: !!messages })
    }
  }, [locale, messages])

  try {
    // @ts-ignore
    return (
      // @ts-ignore
      <Provider locale={locale} messages={messages} timeZone={nextIntlConfig?.timeZone ?? "UTC"}>
        {children}
      </Provider>
    )
  } catch (err) {
    console.error("NextIntlProviderClient render error:", err)
    // fallback to children so page still renders
    return <>{children}</>
  }
}

// No import path to update, but comments and debug output should reference messages/ if present.
